type WaveDividerProps = {
  color?: string;
  flip?: boolean;
  className?: string;
  bgColor?: string;
};

export default function WaveDivider({ color = 'white', flip = false, className = '', bgColor = 'bg-primary' }: WaveDividerProps) {
  return (
    <div className={`w-full overflow-hidden leading-none ${bgColor} ${flip ? 'scale-y-[-1]' : ''} ${className}`} aria-hidden>
      <svg
        viewBox="0 0 1440 56"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        className="w-full h-10 md:h-14 block"
      >
        <path fill={color} d="M0,28 C240,56 480,0 720,28 C960,56 1200,0 1440,28 L1440,56 L0,56 Z" />
      </svg>
    </div>
  );
}
